<template>
    <div :class="contentClass" class="fill-height mb-8" v-bind="$attrs" style="width: 100%">
        <v-overlay v-if="overlay" :value="isLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <div v-if="!overlay && isLoading" class="d-flex pt-10 align-center justify-center" style="width: 80%">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </div>

        <div v-show="!isLoading" style="height: 25vh; width: 100%">
            <iframe data-cy="info-dialog-video" @load="onLoad" style="width: inherit; height: inherit" :src="finalUrl" modestbranding="1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        layout: {
            type: Object,
            required: true,
        },

        overlay: {
            type: Boolean,
            default: false,
        },

        contentClass: String,
    },
    computed: {
        finalUrl() {
            if (!this.layout?.url) return;

            // "?autoplay=1" for Vimeo and Youtube. Other platforms might not support this.
            return this.layout.auto_play ? this.layout.url + '?autoplay=1&mute=1' : this.layout.url + '?mute=1';
        },
    },

    data() {
        return {
            isLoading: true,
        };
    },

    methods: {
        onLoad() {
            this.isLoading = false;
        },
    },
};
</script>
